module.exports = __webpack_public_path__ + "img/emptyAddressImage.7b183cb.svg";